import React from "react";

import Footer from "../components/footer.js";

//styling
import '../app/App.css';

const Contact = () => {
    return (
        <div className="centered" style={{backgroundColor: "#FFFBF3" , height: "100%"}}>
            <h1 className="header"><br />Contact us!</h1>
            <h2 className="subheader"><br />thebobaface@gmail.com.</h2>
            {<Footer />}
        </div>
    )
}

export default Contact;